import TermsAndConditions from '@src/components/TermsAndConditions'
import { getUpsellVariation } from '@src/state/featureFlags/selectors'
import { UpsellVariation } from '@src/state/featureFlags/types'
import { RootState } from '@src/state/types'
import {
  SEE_MY_RESULTS,
  selectShowTermsLink,
  START_FREE_TRIAL,
} from '@src/state/workspace/selectors'
import { ACCESS_PLAGIARISM_CTA } from '@src/utils/dataTestIds'
import * as React from 'react'
import { connect } from 'react-redux'
import { UpgradeButton } from './styled'
import { CtaAndTermsProps, CtaAndTermsStateProps } from './types'

const CtaAndTerms: React.FunctionComponent<CtaAndTermsProps> = ({
  upgrade,
  upsellVariation,
  cspUpsellHasFreeTrial,
}) => {
  const buttonCopy =
    upsellVariation === UpsellVariation.var2 ? START_FREE_TRIAL : SEE_MY_RESULTS

  return (
    <React.Fragment>
      <UpgradeButton onClick={upgrade} data-test={ACCESS_PLAGIARISM_CTA}>
        {buttonCopy}
      </UpgradeButton>
      {cspUpsellHasFreeTrial && <TermsAndConditions />}
    </React.Fragment>
  )
}

const mapStateToProps = (state: RootState) => ({
  upsellVariation: getUpsellVariation(state),
  cspUpsellHasFreeTrial: !!selectShowTermsLink(state),
})

export default connect<CtaAndTermsStateProps>(mapStateToProps)(CtaAndTerms)



// WEBPACK FOOTER //
// ./src/components/PlagiarismLock/CtaAndTerms.tsx